import { Table } from 'src/design/molecules/Table';
import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import { CostCodeAdjustmentItem } from 'src/api/FiretrolApiClient';
import { Currency } from 'src/design/atoms/Currency';
import { YELLOW } from 'src/routes/CTC/ViewCTCJob/components/colors';

interface CostCodeLineProps {
  item: CostCodeAdjustmentItem;
  onChange: (item: CostCodeAdjustmentItem) => void;
}

function isStringNumber(str: string) {
  return !isNaN(Number(str));
}

export const CostCodeLine: React.FC<CostCodeLineProps> = ({
  item,
  onChange,
}) => {
  const isLabor = item.category === 'Labor';
  const [value, setValue] = React.useState(item);

  React.useEffect(() => {
    if (
      value.rate !== item.rate ||
      value.ctc !== item.ctc ||
      value.hours !== item.hours ||
      value.costAtCompletion !== item.costAtCompletion ||
      value.overUnder !== item.overUnder
    ) {
      onChange(value);
    }
  }, [value]);

  const onRateChange = (value: string) => {
    setValue((prevState) => {
      const v = value.length > 0 ? value : 0;
      const ctc = Number(v) * prevState.hours;
      return {
        ...prevState,
        rate: Number(v),
        ctc: ctc,
        costAtCompletion: prevState.jtdCost + ctc,
        overUnder: (prevState.jtdCost + ctc - prevState.revisedEstimate) * -1,
      };
    });
  };

  const onHourChange = (value: string) => {
    setValue((prevState) => {
      const v = value.length > 0 ? value : 0;
      const ctc = Number(v) * prevState.rate;
      return {
        ...prevState,
        hours: Number(v),
        ctc: ctc,
        costAtCompletion: prevState.jtdCost + ctc,
        overUnder: (prevState.jtdCost + ctc - prevState.revisedEstimate) * -1,
      };
    });
  };

  const onCTCChange = (value: string) => {
    setValue((prevState) => {
      const v = value.length > 0 ? value : 0;
      return {
        ...prevState,
        ctc: Number(v),
        costAtCompletion: prevState.jtdCost + Number(v),
        overUnder:
          (prevState.jtdCost + Number(v) - prevState.revisedEstimate) * -1,
      };
    });
  };

  return (
    <Table.Tr>
      <Table.Td
        style={{
          borderBottom: '1px solid #000',
          backgroundColor: '#fff',
        }}
        align="left"
        colSpan={1}
      >
        {value.description}
      </Table.Td>
      <Table.Td
        style={{
          borderBottom: '1px solid #000',
          backgroundColor: YELLOW,
        }}
        align="right"
        colSpan={1}
      >
        {isLabor && (
          <CurrencyInput
            id="input-example"
            name="input-name"
            placeholder="Enter Hours"
            defaultValue={value.hours}
            style={{ width: 125, textAlign: 'right' }}
            decimalsLimit={2}
            onValueChange={(v: string, event: any) => {
              if (isStringNumber(v) && Number(v) !== value.hours) {
                onHourChange(v);
              }
            }}
          />
        )}
      </Table.Td>
      <Table.Td
        style={{
          borderBottom: '1px solid #000',
          backgroundColor: YELLOW,
        }}
        align="right"
        colSpan={1}
      >
        {isLabor && (
          <CurrencyInput
            id="input-example"
            name="input-name"
            placeholder="Enter Rate"
            prefix="$"
            defaultValue={value.rate}
            style={{ width: 125, textAlign: 'right' }}
            decimalsLimit={2}
            onValueChange={(v: string) => {
              if (isStringNumber(v) && Number(v) !== value.rate) {
                onRateChange(v);
              }
            }}
          />
        )}
        {/*{isLabor && (*/}
        {/*  <input*/}
        {/*    style={{ maxWidth: 75 }}*/}
        {/*    value={value.rate.toLocaleString(undefined, {*/}
        {/*      maximumFractionDigits: 2,*/}
        {/*    })}*/}
        {/*    type="number"*/}
        {/*    // onFocus={handleFocus}*/}
        {/*    onChange={(e) => {*/}
        {/*      console.log('okay: ', e.target.value);*/}
        {/*      onRateChange(e.target.value);*/}
        {/*    }}*/}
        {/*  />*/}
        {/*)}*/}
      </Table.Td>
      <Table.Td
        style={{
          borderBottom: '1px solid #000',
          backgroundColor: YELLOW,
        }}
        align="right"
        colSpan={1}
      >
        {isLabor ? (
          <> {<Currency precise value={value.ctc} />}</>
        ) : (
          <CurrencyInput
            id="input-example"
            name="input-name"
            placeholder="Enter CTC"
            style={{ width: 125, textAlign: 'right' }}
            defaultValue={value.ctc}
            prefix="$"
            decimalsLimit={2}
            onValueChange={(v: string) => {
              if (isStringNumber(v) && Number(v) !== value.ctc) {
                onCTCChange(v);
              }
            }}
          />
        )}
      </Table.Td>
      <Table.Td
        style={{
          borderBottom: '1px solid #000',
          backgroundColor: YELLOW,
        }}
        align="right"
        colSpan={1}
      >
        {<Currency precise value={value.costAtCompletion} />}
      </Table.Td>
      <Table.Td
        style={{
          borderBottom: '1px solid #000',
          backgroundColor: '#fff',
        }}
        align="right"
        colSpan={1}
      >
        <span className={value.overUnder < 0 ? 'text-danger' : 'text-success'}>
          {<Currency precise value={value.overUnder} />}
        </span>
      </Table.Td>
    </Table.Tr>
  );
};
